<template>
  <MarketViewLiveDetailV5American v-if="getGameConsole === 'american'"/>
  <MarketViewLiveDetailV5Terminal v-else-if="getGameConsole === 'terminal'"/>
  <MarketViewLiveDetailV5Classic v-else/>
</template>

<script>
import {mapGetters} from 'vuex';

import MarketViewLiveDetailV5American from "@/components/american/MarketViewLiveDetailV5American.vue";
import MarketViewLiveDetailV5Classic from "@/components/center_widgets/Live/MarketViewLiveDetailV5Classic.vue";
import MarketViewLiveDetailV5Terminal from "@/components/terminal/MarketViewLiveDetailV5Terminal.vue";

export default {
  name: 'LiveDetailV16',
  components: {
    MarketViewLiveDetailV5American,
    MarketViewLiveDetailV5Classic,
    MarketViewLiveDetailV5Terminal
  },
  data: () => ({

  }),
  created() {
  },
  computed: {
    ...mapGetters({
      'getGameConsole': 'settings/getGameConsole',
    })

  }
};
</script>


